import React from 'react';
import { Typography, Box } from '@mui/material';
import { ImpactReportType } from 'store/charities/types';
import { causesState } from 'store/causes/causes.slice';
import { useAppSelector } from 'store/hooks';
import { CauseType } from 'store/causes/types';

const getOrdinalSuffix = (day: number): string => {
   if (day > 3 && day < 21) return 'th';
   switch (day % 10) {
      case 1:
         return 'st';
      case 2:
         return 'nd';
      case 3:
         return 'rd';
      default:
         return 'th';
   }
};

const LastUpdates = ({
   impactReports,
   fixedPcitureHeight,
}: {
   impactReports: ImpactReportType[];
   fixedPcitureHeight?: number;
}) => {
   const { causesList } = useAppSelector(causesState);

   const screenWidth = window.innerWidth;
   const imactImageHeight = fixedPcitureHeight ?? (screenWidth * 140) / 390;

   const getCauseTitle = (causeId: number) => {
      if (causesList && causesList.length > 0) {
         return causesList.find((cause) => cause.id === causeId)?.title;
      }
      return '';
   };

   return (
      <Box
         sx={{
            mt: 2.5,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
         }}
      >
         <Box sx={{ mb: 2.5 }}>
            <Typography sx={{ fontSize: 18, fontWeight: 700, color: '#333333' }}>Last Updates</Typography>
         </Box>
         <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
            {impactReports.map((report) => (
               <Box
                  key={report.id}
                  sx={{
                     border: '1px solid #00000010',
                     display: 'flex',
                     borderRadius: '6px',
                     overflow: 'hidden',
                     flexDirection: 'column',
                     backgroundColor: '#FFFFFF',
                  }}
               >
                  <Box
                     sx={{
                        p: 1.25,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'end',
                        rowGap: '6px',
                        width: '100%',
                        height: imactImageHeight,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundImage: `linear-gradient(180deg, #00000000 0%, #00000050 50%, #00000050 50%), url(${report.displayImage})`,
                     }}
                  >
                     <Box
                        sx={{
                           width: 'fit-content',
                           borderRadius: '4px',
                           backgroundColor: '#EFCAC9',
                           py: 0.5,
                           px: 0.75,
                        }}
                     >
                        <Typography sx={{ fontSize: 10, lineHeight: '10px', fontWeight: 700, color: '#333333' }}>
                           {getCauseTitle(report.causeId)}
                        </Typography>
                     </Box>
                     <Typography sx={{ fontSize: 22, lineHeight: '26px', fontWeight: 700, color: '#FFFFFF' }}>
                        {report.title}
                     </Typography>
                  </Box>
                  <Box sx={{ p: 1.25 }}>
                     <Typography sx={{ fontSize: 14, lineHeight: '18px', color: '#666666' }}>{report.body}</Typography>
                     <Box
                        sx={{
                           cursor: 'pointer',
                           mt: 2,
                           display: 'flex',
                           flexDirection: 'row',
                           justifyContent: 'space-between',
                           alignItems: 'center',
                        }}
                     >
                        <Box>
                           <Typography sx={{ fontSize: 12, lineHeight: '18px', fontWeight: 700, color: '#666666' }}>
                              {(() => {
                                 const date = new Date(report.created);
                                 const day = date.getDate();
                                 const month = date.toLocaleDateString('en-US', { month: 'long' });
                                 const year = date.getFullYear();
                                 return `${month} ${day}${getOrdinalSuffix(day)}, ${year}`;
                              })()}
                           </Typography>
                        </Box>
                     </Box>
                  </Box>
               </Box>
            ))}
         </Box>
      </Box>
   );
};

export default LastUpdates;
